
export * from '../../frontend-js-dependencies-web/__liferay__/exports/react-dropzone.js';

import __default__ from '../../frontend-js-dependencies-web/__liferay__/exports/react-dropzone.js';
export default __default__;
